import React from "react";
import styles from "./MenuInput.module.scss";

const MenuInput = (props: any) => {
  return (
    <div className={styles.menuInput}>
      <input
        placeholder={props.children}
        onChange={props.onChange}
        value={props.value}
        type="text"
        autoFocus={props.autoFocus}
      />
      <button type="submit" style={{ border: 'none', background: 'none' }}>
        <img src="/icons/magnifying-glass.svg" alt="search" />
      </button>
    </div>
  );
};

export default MenuInput;
